import * as React from "react";
import {isEmpty as _isEmpty} from "lodash";
import {IDoctorCheckInInfo} from "@curefit/care-common";

interface AddtionalInstructionsViewProps {
    followUps: IDoctorCheckInInfo[];
    referrals: IDoctorCheckInInfo[];
}
const AddtionalInstructionsView: React.StatelessComponent<AddtionalInstructionsViewProps> = (props: AddtionalInstructionsViewProps) => {
    return <div className={"medicine-prescription-view-container"}>
        {props.referrals && props.referrals.length > 0 && <table style={{tableLayout: "auto", width: "70%"}}>
            <thead>
            <tr>
                <th>SPECIALITY</th>
                <th>REASON</th>
            </tr>
            </thead>
            <tbody>
            {props.referrals && props.referrals.map((refferal, index) => {
                return <tr key={index}>
                    <td className="highlighted-text">{!_isEmpty(refferal.doctorType) ? refferal.doctorType.code : refferal.doctorSpecialityCode}</td>
                    <td>{refferal.comment}</td>
                </tr>
            })}
            </tbody>
        </table>}
        <br/>
        {props.followUps && props.followUps.length > 0 && <div>
            <table style={{tableLayout: "auto", width: "50%"}}>
                <thead>
                <tr>
                    <th>FOLLOW - UP</th>
                    <th>SAFETY NETTING</th>
                </tr>
                </thead>
                <tbody>
                {props.followUps && props.followUps.map((followUp, index) => {
                    return <tr key={index}>
                        <td className="highlighted-text">{followUp.followup && followUp.followup.unit && <span>{followUp.followup.count} {followUp.followup.unit.toLowerCase()}</span>}</td>
                        <td>{followUp.comment}</td>
                    </tr>
                })}
                </tbody>
            </table>
        </div>}
    </div>
}

export default AddtionalInstructionsView;